/**
 * A Pokémon type's colour as a hex string for the native HUDs (2026-09-30
 * owner ask: the card's move pills in their type colours, as in the app).
 * The app's own palette (lib/types ALL_TYPES) is the source; the native
 * side cannot read CSS, so the hex travels over the bridge.
 */
import { ALL_TYPES } from "./types";
import { moveTypeFor } from "./moveTypeLookup";

const HEX = new Map<string, string>(ALL_TYPES.map((t) => [t.key, t.color]));

export function typeHex(typeKey: string | null | undefined): string {
  if (!typeKey) return "";
  return HEX.get(typeKey) ?? "";
}

/** The hex colour of a move's type, "" when the move is unknown. */
export function moveTypeHex(moveName: string): string {
  return typeHex(moveTypeFor(moveName));
}
